const root = "/billing-accounts";

export const billingAccountRoutes = {
  root: root,
  detail: (billingAccountCode: string) => ({
    root: `${root}/${billingAccountCode}`,
    subscriptions: `${root}/${billingAccountCode}/subscriptions`,
    history: `${root}/${billingAccountCode}/history`,
  }),
};
